var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 h-100"},[(_vm.sessionReplayUri)?_c('iframe',{ref:"sessionReplayer",staticClass:"w-100 border-0 overflow-hidden",attrs:{"referrerpolicy":"origin-when-cross-origin","allowfullscreen":"","src":_vm.sessionReplayUri,"height":"705","scrolling":"no"}}):_c('div',[_vm._v("Oops, something went wrong!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }